import { err, ok } from "./result.js";
import { parse as parseSrc } from "./parser/index.js";
import { buildModel } from "./model/index.js";
import { layout, layoutSync, warmupLayout, isLayoutWarm } from "./layout/index.js";
import { renderSvg } from "./render-svg/index.js";
// [RENDER-SHARED] parse + buildModel is synchronous and shared by sync and async paths.
function parseAndBuild(source) {
    const parsed = parseSrc(source);
    if (!parsed.ok) {
        return parsed;
    }
    return buildModel(parsed.value);
}
function toSvg(laid, opts) {
    return renderSvg(laid, opts);
}
export async function renderToString(source, opts = {}) {
    const model = parseAndBuild(source);
    if (!model.ok) {
        return model;
    }
    const laid = await layout(model.value, opts);
    if (!laid.ok) {
        return laid;
    }
    return ok(toSvg(laid.value, opts));
}
// [RENDER-SYNC] Synchronous renderToString. Caller MUST have awaited `warmupSyncRender()`
// (or any async `renderToString`) at least once before invoking. Uses identical
// parse/buildModel/renderSvg code as the async path; only the layout call differs.
export function renderToStringSync(source, opts = {}) {
    const model = parseAndBuild(source);
    if (!model.ok) {
        return model;
    }
    const laid = layoutSync(model.value, opts);
    if (!laid.ok) {
        return laid;
    }
    return ok(toSvg(laid.value, opts));
}
export async function warmupSyncRender() {
    await warmupLayout();
}
export { isLayoutWarm as isSyncRenderReady };
/** Browser-only: parse SVG string into an SVGElement via DOMParser. */
export async function render(source, opts = {}) {
    const r = await renderToString(source, opts);
    if (!r.ok) {
        return r;
    }
    if (typeof DOMParser === "undefined") {
        return err([
            {
                severity: "error",
                message: "render() requires a browser DOMParser; use renderToString() in Node",
                line: 0,
                col: 0,
                length: 0,
            },
        ]);
    }
    const doc = new DOMParser().parseFromString(r.value, "image/svg+xml");
    const el = doc.documentElement;
    return ok(el);
}
// Layer barrels for direct access
export * as parser from "./parser/index.js";
export * as model from "./model/index.js";
export * as layoutLayer from "./layout/index.js";
export * as renderSvgLayer from "./render-svg/index.js";
export * as converters from "./converters/index.js";
export { ok, err, isOk, isErr, map, mapErr, andThen, andThenAsync, unwrap } from "./result.js";
export { svg, raw } from "./render-svg/index.js";
export { HOME_PAGE_SAMPLE } from "./sample.js";
//# sourceMappingURL=index.js.map